export const setTokens = tokens => {
  const {
    accessToken,
    puzzelToken,
    currentUserVersion,
    refreshToken
  } = tokens;

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('puzzelToken', puzzelToken);
  localStorage.setItem('currentUserVersion', currentUserVersion);
  localStorage.setItem('refreshToken', refreshToken);
}

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  const currentUserVersion = parseInt(localStorage.getItem('currentUserVersion'), 10);
  const newAccessToken = await fetchNewAccessToken(refreshToken, currentUserVersion);
  return newAccessToken;
}

const fetchNewAccessToken = async (refreshToken, currentUserVersion) => {
  const response = await fetch('/refreshToken', {
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      // "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify({
      refreshToken,
      currentUserVersion
    })
  });

  switch (response.status) {
    case 200:
      const res = await response.json();
      const { accessToken, refreshToken, currentUserVersion } = res;
      localStorage.setItem('accessToken', accessToken);
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }
      if (currentUserVersion) {
        localStorage.setItem('currentUserVersion', currentUserVersion);
      }
      return accessToken;
    case 401:
      localStorage.removeItem('accessToken');
      localStorage.removeItem('puzzelToken');
      localStorage.removeItem('currentUserVersion');
      localStorage.removeItem('refreshToken');
      window.location.reload();
      break;
    default:
      return;
  }
}
